export const routes = {
    disclaimer: {
        path: `/disclaimer`,
        name: 'Disclaimer',
    },
    buyer: {
        path: `/buyer`,
        name: 'Buyer Sign-up',
    },
    supplierLandingPage: {
        path: `/supplier/:companyToken`,
        name: 'Supplier Landing Page',
    },
    supplierSignUpForm: {
        path: `/supplier/:companyToken/form`,
        name: 'Supplier Sign-Up',
    },
    supplierPostSignup: {
        path: `/supplier/:companyToken/post-signup`,
        name: 'Post Signup',
    },
    supplierInvoiceSubmissionGuide: {
        path: `/supplier/:companyToken/:submissionMethod/submission-guide`,
        name: 'Invoice Submission Guide',
    },
};
